var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChromecast(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "chromecast_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h32v32H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#chromecast_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26 10v12c0 .55-.196 1.02-.587 1.413A1.926 1.926 0 0124 24h-4.05a.968.968 0 01-.712-.288.968.968 0 01-.288-.712c0-.283.096-.52.288-.712A.968.968 0 0119.95 22H24V10H8v.15c0 .283-.096.52-.287.713A.967.967 0 017 11.15a.967.967 0 01-.713-.287A.968.968 0 016 10.15V10c0-.55.196-1.02.588-1.412A1.926 1.926 0 018 8h16c.55 0 1.02.196 1.413.588.391.391.587.862.587 1.412zM12 24c-.267 0-.5-.08-.7-.238-.2-.158-.325-.37-.375-.637a4.77 4.77 0 00-1.413-2.675A5.07 5.07 0 006.8 19.075a.81.81 0 01-.587-.363A1.237 1.237 0 016 18a.99.99 0 01.275-.712c.183-.192.4-.271.65-.238 1.567.2 2.904.858 4.013 1.975a6.913 6.913 0 011.987 4.025.771.771 0 01-.225.675.948.948 0 01-.7.275zm4 0a.991.991 0 01-.713-.275 1.116 1.116 0 01-.337-.7c-.233-2.133-1.104-3.942-2.612-5.425-1.509-1.483-3.33-2.333-5.463-2.55a.926.926 0 01-.638-.35A1.095 1.095 0 016 14c0-.283.088-.525.263-.725a.685.685 0 01.637-.25c2.683.217 4.967 1.258 6.85 3.125s2.95 4.142 3.2 6.825a.854.854 0 01-.238.725c-.191.2-.429.3-.712.3zm-8.75 0c-.35 0-.646-.12-.888-.363A1.207 1.207 0 016 22.75c0-.35.12-.646.362-.887.242-.242.538-.363.888-.363s.646.12.887.363c.242.241.363.537.363.887s-.12.646-.363.887A1.207 1.207 0 017.25 24z",
    fill: "#fff"
  }))));
}
export default SvgChromecast;